import React, { Component } from 'react';

import APIDocsCurl from 'common/developers/docs/api/APIDocsCurl';
import APIDocsMethod from 'common/developers/docs/api/APIDocsMethod';
import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsListTagsBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">List tags</div>
          <div className="text">
            Returns a list of tags. Include parameters to specify board and&nbsp;pagination. Sorted
            by newest.
          </div>
          <APIDocsTable
            title="Arguments"
            rows={[
              {
                description: 'Your secret API key.',
                heading: 'apiKey',
                subheading: 'string',
              },
              {
                description: "The id of the board you'd like to fetch tags for.",
                heading: 'boardID',
                subheading: 'string (optional)',
              },
              {
                description:
                  "The number of tags you'd like to fetch. Defaults to 10 if not specified.",
                heading: 'limit',
                subheading: 'number (optional)',
              },
              {
                description:
                  "The number of tags you'd like to skip before starting to fetch. Defaults to 0 if not specified.",
                heading: 'skip',
                subheading: 'number (optional)',
              },
            ]}
          />
          <div className="subheading">Returns</div>
          <div className="text">
            A dictionary with a "tags" property that contains an array of tag objects. There's also
            a "hasMore" property that specifies whether this query returns more tags than
            the&nbsp;limit.
          </div>
        </div>
        <div>
          <div className="text">Endpoint</div>
          <Highlight lang="http">https://canny.io/api/v1/tags/list</Highlight>
          <APIDocsMethod />
          <APIDocsCurl
            path="https://canny.io/api/v1/tags/list"
            body={`\\
    -d apiKey=YOUR_API_KEY \\
    -d boardID=553c3ef8b8cdcd1501ba1234`}
          />
          <div className="text">Example Response</div>
          <Highlight lang="json">
            {`{
  "hasMore": false,
  "tags": [{
    "id": "553c3ef8b8cdcd1501ba12bb",
    "board": {
      "created": "2017-08-30T13:32:01.000Z",
      "id": "553c3ef8b8cdcd1501ba4400",
      "name": "Feature Requests",
      "postCount": 99,
      "url": "https://your-company.canny.io/admin/board/feature-requests"
    },
    "created": "2017-08-30T13:32:01.000Z",
    "name": "Example Tag Name",
    "postCount": 12,
    "url": "https://your-company.canny.io/admin/board/feature-requests?tag=example-tag-name"
  }]
}`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
